import { useParams, Link } from 'react-router-dom';
import SEOHead from '../../../components/SEOHead';
import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';

const articles: Record<string, any> = {
  'guide-complet-nettoyage-airbnb': {
    title: 'Guide Complet du Nettoyage Airbnb : Astuces pour des Avis 5 Étoiles',
    category: 'Airbnb',
    date: '15 Mars 2024',
    readTime: '8 min',
    image: 'https://public.readdy.ai/ai/img_res/3d81c30f56da97dcc086d94c12182153.jpg',
    content: `
      <p>Le succès d'un Airbnb repose en grande partie sur la propreté impeccable de votre logement. Des draps fraîchement lavés aux surfaces étincelantes, chaque détail compte pour garantir des avis 5 étoiles et fidéliser vos voyageurs.</p>

      <h2>Pourquoi le Nettoyage Airbnb est Crucial</h2>
      <p>Dans l'industrie de la location courte durée, la propreté n'est pas négociable. Les voyageurs s'attendent à un niveau de propreté équivalent, voire supérieur, à celui d'un hôtel. Un seul commentaire négatif sur la propreté peut sérieusement impacter vos réservations futures.</p>

      <h2>La Checklist Complète du Nettoyage Airbnb</h2>
      
      <h3>Chambre à Coucher</h3>
      <ul>
        <li><strong>Literie :</strong> Changez tous les draps, taies d'oreiller et housses de couette. Utilisez du linge blanc de qualité hôtelière pour une impression de fraîcheur.</li>
        <li><strong>Surfaces :</strong> Dépoussiérez toutes les surfaces, y compris les tables de chevet, lampes et cadres.</li>
        <li><strong>Sols :</strong> Passez l'aspirateur sous le lit et dans tous les coins.</li>
        <li><strong>Placards :</strong> Vérifiez qu'aucun objet du voyageur précédent n'a été oublié.</li>
      </ul>

      <h3>Salle de Bain</h3>
      <ul>
        <li><strong>Désinfection complète :</strong> Toilettes, lavabo, douche/baignoire avec des produits antibactériens.</li>
        <li><strong>Miroirs :</strong> Nettoyez sans traces pour un effet impeccable.</li>
        <li><strong>Serviettes :</strong> Fournissez des serviettes propres et moelleuses, pliées de manière professionnelle.</li>
        <li><strong>Produits d'accueil :</strong> Réapprovisionnez savon, shampoing et papier toilette.</li>
      </ul>

      <h3>Cuisine</h3>
      <ul>
        <li><strong>Électroménagers :</strong> Nettoyez l'intérieur et l'extérieur du réfrigérateur, micro-ondes, four.</li>
        <li><strong>Vaisselle :</strong> Vérifiez que toute la vaisselle est propre et sans traces.</li>
        <li><strong>Plans de travail :</strong> Désinfectez toutes les surfaces de préparation.</li>
        <li><strong>Poubelles :</strong> Videz et nettoyez avec un désinfectant.</li>
      </ul>

      <h3>Espaces Communs</h3>
      <ul>
        <li><strong>Sols :</strong> Aspirez et lavez tous les sols.</li>
        <li><strong>Meubles :</strong> Dépoussiérez et nettoyez canapés, tables, étagères.</li>
        <li><strong>Vitres :</strong> Nettoyez toutes les fenêtres et miroirs.</li>
        <li><strong>Décoration :</strong> Replacez coussins et objets décoratifs de manière harmonieuse.</li>
      </ul>

      <h2>Astuces de Pro pour un Nettoyage Efficace</h2>
      
      <h3>1. Optimisez Votre Temps</h3>
      <p>Créez un système de rotation efficace. Commencez toujours par les tâches qui nécessitent un temps d'action (trempage, désinfection) pendant que vous vous occupez d'autres zones.</p>

      <h3>2. Utilisez les Bons Produits</h3>
      <p>Investissez dans des produits professionnels de qualité. Les produits écologiques sont de plus en plus appréciés par les voyageurs soucieux de l'environnement.</p>

      <h3>3. Créez une Ambiance Accueillante</h3>
      <p>Au-delà de la propreté, pensez à l'expérience globale : ouvrez les fenêtres pour aérer, ajustez la température, disposez une petite attention de bienvenue.</p>

      <h3>4. Photographiez Votre Travail</h3>
      <p>Prenez des photos après chaque nettoyage. Cela vous protège en cas de litige et vous permet de maintenir un standard constant.</p>

      <h2>Erreurs à Éviter</h2>
      <ul>
        <li><strong>Négliger les détails :</strong> Les interrupteurs, poignées de porte et télécommandes sont souvent oubliés mais très visibles.</li>
        <li><strong>Utiliser trop de parfum :</strong> Préférez une odeur neutre et fraîche plutôt qu'un parfum artificiel fort.</li>
        <li><strong>Oublier de vérifier les stocks :</strong> Manquer de papier toilette ou d'essuie-tout peut ruiner l'expérience.</li>
        <li><strong>Bâcler les zones cachées :</strong> Les voyageurs regardent partout, y compris sous les meubles.</li>
      </ul>

      <h2>Quand Faire Appel à un Professionnel</h2>
      <p>Si vous gérez plusieurs propriétés ou si le temps entre deux réservations est court, faire appel à un service de nettoyage professionnel comme Ecomez peut être la solution idéale. Nous garantissons :</p>
      <ul>
        <li>Une rotation rapide entre les clients</li>
        <li>Un nettoyage approfondi et constant</li>
        <li>Une disponibilité flexible selon vos réservations</li>
        <li>Des produits professionnels et écologiques</li>
        <li>Une garantie de satisfaction</li>
      </ul>

      <h2>Conclusion</h2>
      <p>Un nettoyage Airbnb impeccable est votre meilleur investissement pour obtenir des avis 5 étoiles, augmenter votre taux d'occupation et maximiser vos revenus. Que vous le fassiez vous-même ou que vous fassiez appel à des professionnels, la constance et l'attention aux détails sont les clés du succès.</p>

      <p><strong>Besoin d'aide pour le nettoyage de votre Airbnb ?</strong> Contactez Ecomez pour un service professionnel adapté à vos besoins de rotation rapide et de qualité constante.</p>
    `
  },
  'produits-ecologiques-nettoyage-maison': {
    title: '10 Produits Écologiques Essentiels pour un Nettoyage Maison Efficace',
    category: 'Écologie',
    date: '10 Mars 2024',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=eco-friendly%20natural%20cleaning%20products%20with%20green%20plants%2C%20bamboo%20brushes%2C%20glass%20spray%20bottles%2C%20organic%20ingredients%20on%20white%20marble%20counter%2C%20bright%20clean%20aesthetic%2C%20sustainable%20lifestyle%20photography%2C%20simple%20clean%20background&width=1200&height=600&seq=article2&orientation=landscape',
    content: `
      <p>Passer au nettoyage écologique ne signifie pas compromettre l'efficacité. Découvrez notre sélection de produits naturels qui nettoient en profondeur tout en protégeant votre santé et l'environnement.</p>

      <h2>Pourquoi Choisir des Produits Écologiques ?</h2>
      <p>Les produits de nettoyage conventionnels contiennent souvent des substances chimiques nocives qui peuvent irriter la peau, les yeux et les voies respiratoires. Ils polluent également l'eau et l'air de votre maison. Les alternatives écologiques offrent une efficacité comparable sans ces inconvénients.</p>

      <h2>Les 10 Produits Écologiques Essentiels</h2>

      <h3>1. Vinaigre Blanc</h3>
      <p><strong>Utilisations :</strong> Détartrant, désinfectant, dégraissant</p>
      <p>Le vinaigre blanc est le couteau suisse du nettoyage écologique. Il élimine le calcaire, désinfecte les surfaces et fait briller les vitres. Mélangez-le avec de l'eau (50/50) dans un vaporisateur pour un nettoyant multi-usage.</p>

      <h3>2. Bicarbonate de Soude</h3>
      <p><strong>Utilisations :</strong> Abrasif doux, désodorisant, blanchissant</p>
      <p>Parfait pour récurer les surfaces sans les rayer, absorber les odeurs et blanchir le linge. Saupoudrez-en sur les tapis avant de passer l'aspirateur pour éliminer les odeurs.</p>

      <h3>3. Savon de Marseille</h3>
      <p><strong>Utilisations :</strong> Nettoyant universel, lessive</p>
      <p>100% naturel et biodégradable, le savon de Marseille nettoie efficacement toutes les surfaces. Râpez-en quelques copeaux dans de l'eau chaude pour créer un nettoyant liquide polyvalent.</p>

      <h3>4. Huiles Essentielles</h3>
      <p><strong>Utilisations :</strong> Parfum naturel, propriétés antibactériennes</p>
      <p>L'huile essentielle de tea tree est antibactérienne, celle de citron est dégraissante, et la lavande apporte une odeur agréable. Ajoutez quelques gouttes à vos préparations maison.</p>

      <h3>5. Cristaux de Soude</h3>
      <p><strong>Utilisations :</strong> Dégraissant puissant, déboucheur</p>
      <p>Plus puissants que le bicarbonate, les cristaux de soude sont parfaits pour les tâches difficiles : four encrassé, canalisations bouchées, linge très sale.</p>

      <h3>6. Acide Citrique</h3>
      <p><strong>Utilisations :</strong> Détartrant, anticalcaire</p>
      <p>Excellent pour détartrer bouilloires, cafetières et robinetterie. Dissolvez 2 cuillères à soupe dans 500ml d'eau chaude pour un détartrant efficace.</p>

      <h3>7. Savon Noir</h3>
      <p><strong>Utilisations :</strong> Dégraissant, nettoyant sols</p>
      <p>Idéal pour nettoyer les sols, dégraisser la cuisine et même comme insecticide naturel pour les plantes. Diluez 2 cuillères à soupe dans 5 litres d'eau.</p>

      <h3>8. Percarbonate de Sodium</h3>
      <p><strong>Utilisations :</strong> Blanchissant, détachant</p>
      <p>Alternative écologique à l'eau de javel, il blanchit le linge et élimine les taches tenaces. Ajoutez-en à votre lessive habituelle pour un effet blanchissant.</p>

      <h3>9. Terre de Sommières</h3>
      <p><strong>Utilisations :</strong> Détachant à sec</p>
      <p>Parfaite pour absorber les taches grasses sur tissus, tapis et canapés sans eau. Saupoudrez, laissez agir quelques heures, puis aspirez.</p>

      <h3>10. Microfibre</h3>
      <p><strong>Utilisations :</strong> Nettoyage sans produit chimique</p>
      <p>Les chiffons en microfibre nettoient efficacement avec juste de l'eau, capturant poussière et bactéries. Investissez dans plusieurs couleurs pour différentes zones (cuisine, salle de bain, etc.).</p>

      <h2>Recettes Maison Faciles</h2>

      <h3>Nettoyant Multi-Usage</h3>
      <ul>
        <li>500ml d'eau</li>
        <li>250ml de vinaigre blanc</li>
        <li>10 gouttes d'huile essentielle de citron</li>
        <li>1 cuillère à soupe de savon noir</li>
      </ul>
      <p>Mélangez dans un vaporisateur. Utilisez sur toutes les surfaces (sauf marbre).</p>

      <h3>Nettoyant Vitres</h3>
      <ul>
        <li>250ml d'eau</li>
        <li>250ml de vinaigre blanc</li>
        <li>1 cuillère à soupe d'alcool à 70°</li>
      </ul>
      <p>Vaporisez et essuyez avec un chiffon microfibre pour des vitres sans traces.</p>

      <h3>Poudre à Récurer</h3>
      <ul>
        <li>200g de bicarbonate de soude</li>
        <li>100g de cristaux de soude</li>
        <li>10 gouttes d'huile essentielle de tea tree</li>
      </ul>
      <p>Mélangez et conservez dans un bocal. Utilisez avec une éponge humide.</p>

      <h2>Conseils d'Utilisation</h2>
      <ul>
        <li><strong>Étiquetez vos préparations :</strong> Notez la composition et la date de fabrication.</li>
        <li><strong>Testez d'abord :</strong> Essayez sur une petite zone peu visible avant d'utiliser sur toute la surface.</li>
        <li><strong>Ne mélangez pas tout :</strong> Certains produits ne doivent pas être mélangés (vinaigre + bicarbonate s'annulent).</li>
        <li><strong>Conservez correctement :</strong> À l'abri de la lumière et de la chaleur, hors de portée des enfants.</li>
      </ul>

      <h2>Les Avantages du Nettoyage Écologique</h2>
      <ul>
        <li><strong>Économique :</strong> Les produits naturels coûtent beaucoup moins cher que les produits conventionnels.</li>
        <li><strong>Sain :</strong> Pas de substances toxiques dans l'air de votre maison.</li>
        <li><strong>Écologique :</strong> Biodégradables et sans impact sur l'environnement.</li>
        <li><strong>Efficace :</strong> Résultats comparables, voire supérieurs aux produits chimiques.</li>
        <li><strong>Polyvalent :</strong> Quelques produits suffisent pour toute la maison.</li>
      </ul>

      <h2>Conclusion</h2>
      <p>Passer au nettoyage écologique est un choix gagnant pour votre santé, votre portefeuille et la planète. Ces 10 produits essentiels vous permettront de nettoyer efficacement toute votre maison de manière naturelle et responsable.</p>

      <p><strong>Chez Ecomez, nous utilisons prioritairement des produits écologiques pour tous nos services de nettoyage.</strong> Contactez-nous pour un nettoyage professionnel respectueux de votre santé et de l'environnement.</p>
    `
  },
  'nettoyage-printemps-checklist-complete': {
    title: 'Nettoyage de Printemps : La Checklist Complète Pièce par Pièce',
    category: 'Conseils',
    date: '5 Mars 2024',
    readTime: '10 min',
    image: 'https://readdy.ai/api/search-image?query=bright%20sunny%20living%20room%20with%20open%20windows%2C%20fresh%20flowers%2C%20clean%20organized%20space%2C%20spring%20cleaning%20atmosphere%2C%20natural%20daylight%2C%20airy%20fresh%20feeling%2C%20professional%20home%20photography%2C%20simple%20neutral%20background&width=1200&height=600&seq=article3&orientation=landscape',
    content: `
      <p>Le printemps est le moment idéal pour un grand nettoyage en profondeur de votre maison. Suivez notre checklist complète pour un résultat impeccable, pièce par pièce.</p>

      <h2>Pourquoi Faire un Nettoyage de Printemps ?</h2>
      <p>Après l'hiver, votre maison a accumulé poussière, saleté et désordre. Le nettoyage de printemps permet de rafraîchir votre espace, éliminer les allergènes et repartir sur de bonnes bases pour les beaux jours.</p>

      <h2>Préparation : Avant de Commencer</h2>
      <ul>
        <li><strong>Planifiez :</strong> Réservez un week-end complet ou répartissez sur plusieurs jours.</li>
        <li><strong>Rassemblez votre matériel :</strong> Produits de nettoyage, chiffons, aspirateur, sacs poubelle.</li>
        <li><strong>Désencombrez d'abord :</strong> Faites le tri avant de nettoyer pour gagner du temps.</li>
        <li><strong>Travaillez de haut en bas :</strong> Commencez par les plafonds et finissez par les sols.</li>
      </ul>

      <h2>Checklist Pièce par Pièce</h2>

      <h3>Cuisine</h3>
      <ul>
        <li>☐ Vider et nettoyer le réfrigérateur et le congélateur</li>
        <li>☐ Nettoyer l'intérieur et l'extérieur du four</li>
        <li>☐ Détartrer et nettoyer le micro-ondes</li>
        <li>☐ Nettoyer la hotte et changer/nettoyer les filtres</li>
        <li>☐ Vider et organiser les placards et tiroirs</li>
        <li>☐ Vérifier les dates de péremption</li>
        <li>☐ Nettoyer les joints de carrelage</li>
        <li>☐ Détartrer robinets et évier</li>
        <li>☐ Nettoyer derrière et sous les électroménagers</li>
        <li>☐ Laver les torchons et maniques</li>
        <li>☐ Nettoyer les poubelles</li>
      </ul>

      <h3>Salle de Bain</h3>
      <ul>
        <li>☐ Détartrer robinets, pommeaux de douche et joints</li>
        <li>☐ Nettoyer en profondeur toilettes, lavabo, douche/baignoire</li>
        <li>☐ Laver rideaux de douche ou joints de paroi</li>
        <li>☐ Vider et organiser armoires et tiroirs</li>
        <li>☐ Jeter produits périmés</li>
        <li>☐ Nettoyer miroirs sans traces</li>
        <li>☐ Laver tapis de bain et serviettes</li>
        <li>☐ Nettoyer ventilation</li>
        <li>☐ Désinfecter interrupteurs et poignées</li>
      </ul>

      <h3>Chambres</h3>
      <ul>
        <li>☐ Laver toute la literie (draps, couettes, oreillers)</li>
        <li>☐ Retourner et aspirer le matelas</li>
        <li>☐ Trier et organiser les vêtements</li>
        <li>☐ Faire don des vêtements non portés</li>
        <li>☐ Nettoyer l'intérieur des placards</li>
        <li>☐ Dépoussiérer tous les meubles</li>
        <li>☐ Nettoyer sous le lit</li>
        <li>☐ Laver rideaux ou stores</li>
        <li>☐ Nettoyer vitres et rebords de fenêtres</li>
        <li>☐ Aspirer et laver les sols</li>
      </ul>

      <h3>Salon</h3>
      <ul>
        <li>☐ Dépoussiérer plafond, murs et plinthes</li>
        <li>☐ Nettoyer luminaires et abat-jours</li>
        <li>☐ Aspirer et nettoyer canapés et fauteuils</li>
        <li>☐ Laver coussins et plaids</li>
        <li>☐ Nettoyer en profondeur tapis et moquettes</li>
        <li>☐ Dépoussiérer livres et étagères</li>
        <li>☐ Nettoyer écrans TV et ordinateurs</li>
        <li>☐ Organiser câbles et fils électriques</li>
        <li>☐ Nettoyer vitres et cadres de fenêtres</li>
        <li>☐ Aspirer derrière et sous les meubles</li>
      </ul>

      <h3>Bureau/Espace de Travail</h3>
      <ul>
        <li>☐ Trier et organiser documents</li>
        <li>☐ Numériser et archiver papiers importants</li>
        <li>☐ Nettoyer clavier, souris et écran</li>
        <li>☐ Organiser câbles et accessoires</li>
        <li>☐ Vider et nettoyer tiroirs</li>
        <li>☐ Dépoussiérer étagères et fournitures</li>
        <li>☐ Jeter stylos qui ne fonctionnent plus</li>
      </ul>

      <h3>Entrée/Couloirs</h3>
      <ul>
        <li>☐ Trier chaussures et manteaux</li>
        <li>☐ Nettoyer miroirs et porte-manteaux</li>
        <li>☐ Laver paillassons</li>
        <li>☐ Dépoussiérer cadres et décorations</li>
        <li>☐ Nettoyer interrupteurs et poignées</li>
        <li>☐ Aspirer et laver les sols</li>
      </ul>

      <h3>Buanderie/Garage</h3>
      <ul>
        <li>☐ Nettoyer machine à laver et sèche-linge</li>
        <li>☐ Organiser produits de nettoyage</li>
        <li>☐ Trier outils et équipements</li>
        <li>☐ Jeter ou donner objets inutilisés</li>
        <li>☐ Balayer et nettoyer les sols</li>
      </ul>

      <h2>Tâches Générales pour Toute la Maison</h2>
      <ul>
        <li>☐ Dépoussiérer ventilateurs de plafond</li>
        <li>☐ Nettoyer grilles de ventilation et radiateurs</li>
        <li>☐ Changer filtres de climatisation/chauffage</li>
        <li>☐ Nettoyer toutes les vitres intérieures et extérieures</li>
        <li>☐ Laver rideaux et stores</li>
        <li>☐ Nettoyer plinthes et encadrements de portes</li>
        <li>☐ Désinfecter interrupteurs, poignées et télécommandes</li>
        <li>☐ Nettoyer luminaires et remplacer ampoules grillées</li>
      </ul>

      <h2>Conseils pour un Nettoyage Efficace</h2>

      <h3>1. Travaillez Méthodiquement</h3>
      <p>Terminez complètement une pièce avant de passer à la suivante. Cela vous donne un sentiment d'accomplissement et évite de vous disperser.</p>

      <h3>2. Utilisez la Règle des 4 Cartons</h3>
      <p>Lors du désencombrement, utilisez 4 cartons : À garder, À donner, À vendre, À jeter. Cela facilite le tri et les décisions.</p>

      <h3>3. Faites Participer la Famille</h3>
      <p>Répartissez les tâches selon l'âge et les capacités de chacun. Le nettoyage de printemps devient plus rapide et convivial.</p>

      <h3>4. Mettez de la Musique</h3>
      <p>Une playlist entraînante rend le nettoyage plus agréable et vous motive à continuer.</p>

      <h3>5. Récompensez-vous</h3>
      <p>Prévoyez une récompense après chaque pièce terminée : pause café, snack préféré, épisode de série...</p>

      <h2>Quand Faire Appel à un Professionnel</h2>
      <p>Le nettoyage de printemps est une tâche importante qui peut prendre plusieurs jours. Si vous manquez de temps ou si certaines tâches vous semblent trop difficiles, faire appel à un service professionnel comme Ecomez peut être la solution idéale.</p>

      <p><strong>Nos services de nettoyage de printemps incluent :</strong></p>
      <ul>
        <li>Nettoyage en profondeur de toutes les pièces</li>
        <li>Nettoyage des vitres intérieures et extérieures</li>
        <li>Nettoyage des tapis et moquettes</li>
        <li>Nettoyage des électroménagers</li>
        <li>Dépoussiérage complet</li>
        <li>Produits écologiques inclus</li>
      </ul>

      <h2>Conclusion</h2>
      <p>Un nettoyage de printemps complet transforme votre maison et vous permet de profiter pleinement des beaux jours dans un environnement frais et sain. Suivez cette checklist pour ne rien oublier et obtenir un résultat professionnel.</p>

      <p><strong>Besoin d'aide pour votre nettoyage de printemps ?</strong> Contactez Ecomez pour un service complet et professionnel qui vous fera gagner du temps et de l'énergie.</p>
    `
  }
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? articles[slug] : null;

  if (!article) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="max-w-4xl mx-auto px-6 py-20 text-center">
          <i className="ri-file-search-line text-6xl text-gray-400 mb-4"></i>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Article non trouvé</h1>
          <Link to="/blog" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">
            ← Retour au blog
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": article.title,
    "image": article.image,
    "datePublished": article.date,
    "author": {
      "@type": "Organization",
      "name": "Ecomez"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Ecomez",
      "logo": {
        "@type": "ImageObject",
        "url": "https://readdy.ai/api/search-image?query=ecomez-logo&width=200&height=60&seq=logo&orientation=landscape"
      }
    },
    "description": article.title
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead structuredData={structuredData} />
      <Header />
      
      <main>
        {/* Article Header */}
        <article className="max-w-4xl mx-auto px-6 py-12">
          <Link 
            to="/blog" 
            className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold mb-8 cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Retour au blog
          </Link>

          <div className="mb-8">
            <span className="bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-medium">
              {article.category}
            </span>
          </div>

          <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
            {article.title}
          </h1>

          <div className="flex items-center text-gray-600 mb-8">
            <i className="ri-calendar-line mr-2"></i>
            <span>{article.date}</span>
            <span className="mx-3">•</span>
            <i className="ri-time-line mr-2"></i>
            <span>{article.readTime} de lecture</span>
          </div>

          <div className="relative h-96 rounded-2xl overflow-hidden mb-12">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Article Content */}
          <div 
            className="prose prose-lg max-w-none"
            dangerouslySetInnerHTML={{ __html: article.content }}
            style={{
              lineHeight: '1.8',
            }}
          />

          {/* Share Section */}
          <div className="mt-16 pt-8 border-t border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Partager cet article</h3>
            <div className="flex gap-4">
              <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300 cursor-pointer whitespace-nowrap flex items-center">
                <i className="ri-facebook-fill mr-2"></i>
                Facebook
              </button>
              <button className="bg-sky-500 text-white px-6 py-3 rounded-lg hover:bg-sky-600 transition-colors duration-300 cursor-pointer whitespace-nowrap flex items-center">
                <i className="ri-twitter-fill mr-2"></i>
                Twitter
              </button>
              <button className="bg-blue-700 text-white px-6 py-3 rounded-lg hover:bg-blue-800 transition-colors duration-300 cursor-pointer whitespace-nowrap flex items-center">
                <i className="ri-linkedin-fill mr-2"></i>
                LinkedIn
              </button>
            </div>
          </div>

          {/* CTA Section */}
          <div className="mt-16 bg-gradient-to-br from-teal-50 to-white rounded-2xl p-12 text-center">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Besoin d'un Service de Nettoyage Professionnel ?
            </h3>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Ecomez vous offre des services de nettoyage de qualité pour votre maison, bureau ou Airbnb. Contactez-nous pour un devis gratuit.
            </p>
            <Link
              to="/#reservation"
              className="inline-block bg-teal-600 text-white px-8 py-4 rounded-full hover:bg-teal-700 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Réserver Maintenant
            </Link>
          </div>
        </article>

        {/* Related Articles */}
        <section className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Articles Similaires
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {Object.entries(articles)
                .filter(([key]) => key !== slug)
                .slice(0, 3)
                .map(([key, post]) => (
                  <Link
                    key={key}
                    to={`/blog/${key}`}
                    className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6">
                      <span className="text-teal-600 text-sm font-medium">{post.category}</span>
                      <h3 className="text-xl font-bold text-gray-900 mt-2 mb-3 group-hover:text-teal-600 transition-colors duration-300">
                        {post.title}
                      </h3>
                      <div className="flex items-center text-sm text-gray-500">
                        <span>{post.date}</span>
                        <span className="mx-2">•</span>
                        <span>{post.readTime}</span>
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
